module.exports = new __parcel__URL__("wet-dream.83df5046.jpg").toString();